import { useEffect } from "react";
import { motion } from "framer-motion";
import { FADE_UP } from "@/lib/motionPresets";
import { DiagnosticInauguralWidget } from "@/components/DiagnosticInauguralWidget";
import { useLang } from "@/lib/siteI18n";

export default function DiagnosticInaugural() {
  const { lang, t } = useLang();
  useEffect(() => {
    document.title = "Diagnostic Inaugural — Chemin de Vie & Kua Lo Shu | Académie AETHERIS";
  }, []);

  return (
    <div className="min-h-screen bg-brand-ink text-white pt-28 pb-24" data-testid="diagnostic-inaugural-page">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <motion.header {...FADE_UP} className="mb-14 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.25em] mb-5" style={{ color: "#C9A84C" }}>{t.di.kicker}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            {t.di.title} <span style={{ color: "#C9A84C" }}>{t.di.titleAccent}</span>
          </h1>
          <p className="text-white/60 text-base md:text-lg font-light mt-6 leading-relaxed">
            {t.di.intro}
          </p>
        </motion.header>
        <DiagnosticInauguralWidget key={lang} initialLang={lang} />
      </div>
    </div>
  );
}
